import axios from "axios";
import { APIURL } from "../Constantes";
import { getCabecera } from "../utils/getCabecera";
import { getError } from "../utils/errors"
const urlTrip = "Trip";

export const getCalendario = async ({ anho, mes }) => {
    return axios.get(`${APIURL}/${urlTrip}/Calendar/${mes}/${anho}`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            //return Error.response.data;
            return [];
        })
}
export const getEventoFecha = async ({ fecha }) => {
    return axios.get(`${APIURL}/${urlTrip}/Date/${fecha}`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            //return Error.response.data;
            return {};
        })
}
export const getEventoMes = async ({ anho, mes }) => {
    return axios.get(`${APIURL}/${urlTrip}/Events/${mes}/${anho}`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            //return Error.response.data;
            return {};
        })
}
export const getDetalleGrupo = async ({ fecha, nombre }) => {
    return axios.get(`${APIURL}/${urlTrip}/Datails/${fecha}/${nombre}`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            //return Error.response.data;
            return {};
        })
}
export const getTripIdPaquete = async ({ IdPaquete }) => {
    return await axios.get(`${APIURL}/${urlTrip}/${IdPaquete}`, {
        headers: getCabecera()
    })
        .then((Response) => {
            return Response.data;
        })
        .catch((Error) => {
            // return getError(Error);
            return {}
        })
}

export const getViajeReferencia = async ({ referencia }) => {
    return axios.get(`${APIURL}/${urlTrip}/Reference/${referencia}`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            //return Error.response.data;
            return {};
        })
}

export const getDetallePaqueteRefencia = async ({ idPaquete, referencia }) => {
    return axios.get(`${APIURL}/${urlTrip}/Datails/Package/${idPaquete}/${referencia}`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            //return Error.response.data;
            return {};
        })
}

export const getDocuementosCuentaPaquete = async ({ idCuenta, idPaquete }) => {
    return axios.get(`${APIURL}/${urlTrip}/Documents/${idCuenta}/${idPaquete}`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            //return Error.response.data;
            return [];
        })
}

/**
 * TODO: Metodos cliente
*/
export const getListadoClientes = async () => {
    return axios.get(`${APIURL}/${urlTrip}/Listado`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            //return Error.response.data;
            return [];
        })
}

export const getReporteReferencias = async () => {
    return axios.get(`${APIURL}/${urlTrip}/Reporte/Listado`, {
        headers: getCabecera(),
        responseType: 'blob'
    }).then((Response) => {
        return Response;
    }).catch((Error) => {
        //return getError(Error);
        return []
    })
}

export const getMovimientosCuentaCliente = async ({ Referencia, Pagina, Registros }) => {
    return axios.get(`${APIURL}/${urlTrip}/Movimientos/${Referencia}/${Pagina}/${Registros}`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            //return Error.response.data;
            return [];
        })
}
export const getMovimientosCuentaMain = async ({ Referencia, Pagina, Registros }) => {
    return axios.get(`${APIURL}/${urlTrip}/Transactions/CashRegister/${Referencia}/${Pagina}/${Registros}`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            //return Error.response.data;
            return [];
        })
}
/**
 * TODO: Metodos reservas
*/
//* GET /api/Trip/Reserve/{Referencia}/{EstatusCompra}/{Pagina}/{Registros}
export const getReservasAll = async ({ Referencia, EstatusCompra, Pagina, Registros }) => {
    return axios.get(`${APIURL}/${urlTrip}/Reserve/${Referencia}/${EstatusCompra}/${Pagina}/${Registros}`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            //return Error.response.data;
            return {};
        })
}
export const getReservasAutorizadas = async ({ FechaInicio, FechaFin, Pagina, Registros }) => {
    return axios.get(`${APIURL}/${urlTrip}/Reserve/Authorized/${FechaInicio}/${FechaFin}/${Pagina}/${Registros}`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            //return Error.response.data;
            return {};
        })
}
//* Obtine las reservas que su fecha de viaje ya no es vigente
//* GET Trip/Reserve/ExpiredDate/{Referencia}/{EstatusCompra}/{Pagina}/{Registros}
export const getReservasExperidas = async ({ referencia, estusCompra, pagina, registros }) => {
    return axios.get(`${APIURL}/${urlTrip}/Reserve/ExpiredDate/${referencia}/${estusCompra}/${pagina}/${registros}`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data
        }).catch((Error) => {
            return {};
        })
}
/**
 * TODO: Metodos aereos
*/
//* Obtener aereos all sin busqueda
export const getAereosAll = async ({ Pagina, Registros }) => {
    return axios.get(`${APIURL}/${urlTrip}/Aerial/${Pagina}/${Registros}`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            //return Error.response.data;
            return {};
        })
}
//* Obtener aereos all busqueda clave viaje
//* GET api/Aerial/{ClaveViaje}/{Pagina}/{Registros}
export const getAereosAllClaveViaje = async ({ ClaveViaje, Pagina, Registros }) => {
    return axios.get(`${APIURL}/${urlTrip}/Aerial/${ClaveViaje}/${Pagina}/${Registros}`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            //return Error.response.data;
            return {};
        })
}
export const getAereosClaveViaje = async ({ ClaveViaje }) => {
    return axios.get(`${APIURL}/${urlTrip}/Aerial/KeyTravel/${ClaveViaje}`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            //return Error.response.data;
            return [];
        })
}
export const getAereosAutorizados = async ({ FechaInicio, FechaFin, Pagina, Registros }) => {
    return axios.get(`${APIURL}/${urlTrip}/Aerial/Authorized/${FechaInicio}/${FechaFin}/${Pagina}/${Registros}`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            //return Error.response.data;
            return {};
        })
}
export const getAereosClaveViajeAutorizados = async ({ IdPagoGrupal }) => {
    return axios.get(`${APIURL}/${urlTrip}/Aerial/Authorized/PayGroup/${IdPagoGrupal}`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            //return Error.response.data;
            return [];
        })
}
/**
 * TODO: Metodos liquidacion
*/
//*Obtener todas liquidaciones busqueda
//*GET /api/Trip/Liquidation/{ClaveViaje}/{Pagina}/{Registros}
export const getLiquidadcionesAllBusqueda = async ({ ClaveViaje, Pagina, Registros }) => {
    return axios.get(`${APIURL}/${urlTrip}/Liquidation/${ClaveViaje}/${Pagina}/${Registros}`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            //return Error.response.data;
            return {};
        })
}
//*Obtener todas liquidaciones solo paginacion 
export const getLiquidadcionesAll = async ({ Pagina, Registros }) => {
    return axios.get(`${APIURL}/${urlTrip}/Liquidation/${Pagina}/${Registros}`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            //return Error.response.data;
            return {};
        })
}
export const getLiquidacionesClaveViaje = async ({ ClaveViaje }) => {
    return axios.get(`${APIURL}/${urlTrip}/Liquidation/KeyTravel/${ClaveViaje}`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            //return Error.response.data;
            return [];
        })
}
export const getLiquidacionesAutorizados = async ({ FechaInicio, FechaFin, Pagina, Registros }) => {
    return axios.get(`${APIURL}/${urlTrip}/Liquidation/Authorized/${FechaInicio}/${FechaFin}/${Pagina}/${Registros}`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            //return Error.response.data;
            return {};
        })
}
export const getLiquidacionesAutorizadosGrupo = async ({ IdPagoGrupal }) => {
    return axios.get(`${APIURL}/${urlTrip}/Liquidation/Authorized/PayGroup/${IdPagoGrupal}`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            //return Error.response.data;
            return {};
        })
}
export const getListadoClaveViaje = async ({ ClavePaquete }) => {
    return axios.get(`${APIURL}/${urlTrip}/KeyTravel/${ClavePaquete}`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            //return Error.response.data;
            return [];
        })
}

/*
* Consulta utilidad por grupo
*/
export const getGrupoViajeUtilidad = async ({ ClaveViaje }) => {
    return axios.get(`${APIURL}/${urlTrip}/Details/TravelKey/${ClaveViaje}`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            //return Error.response.data;
            return {};
        })
}
export const getGrupoViajeUtilidadFecha = async ({ FechaIni, FechaFin }) => {
    return axios.get(`${APIURL}/${urlTrip}/Details/Date/${FechaIni}/${FechaFin}`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            //return Error.response.data;
            return {};
        })
}
// * Metodos para la consulta de paquetes por fecha de salida

export const getPaqueteViajeFecha = async ({ FechaSalida }) => {
    return axios.get(`${APIURL}/${urlTrip}/TravelDate/${FechaSalida}`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            //return Error.response.data;
            return [];
        })
}
// * Metodo para aceptar teminos y condiciones del cliente
export const postReferenciaTerminos = async ({ Referencia }) => {
    return axios.post(`${APIURL}/${urlTrip}/TermCondition`, {
        Referencia
    },
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            return getError(Error)
        })
}

//* GET /api/Trip/Extra/{Referencia}/{Pagina}/{Registros}
//* Metodos para obtener extras pendientes por aprobar (modulo de extras)
export const getExtrasAprobadosAgente = async ({ Referencia, Pagina, Registros }) => {
    return axios.get(`${APIURL}/${urlTrip}/Extra/${Referencia}/${Pagina}/${Registros}`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            //return Error.response.data;
            return [];
        })
}
//* GET /api/Trip/Extra/{Referencia}/{Pagina}/{Registros}/{IdCatVersionPaquete}
//* Metodos para obtener extras pendientes por aprobar (modulo de extras) por version de paquete
export const getExtrasAprobadosAgenteVersion = async ({ Referencia, Pagina, Registros, IdCatVersionPaquete }) => {
    return axios.get(`${APIURL}/${urlTrip}/Extra/${Referencia}/${Pagina}/${Registros}/${IdCatVersionPaquete}`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            //return Error.response.data;
            return [];
        })
}
//* GET /api/Trip/Extra/Reviewed/{Referencia}/{Pagina}/{Registros}
//* Metodos para obtener los extras pagados (finanzas)
export const getExtrasAprobadosFinanzas = async ({ Referencia, Pagina, Registros }) => {
    return axios.get(`${APIURL}/${urlTrip}/Extra/Reviewed/${Referencia}/${Pagina}/${Registros}`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            //return Error.response.data;
            return [];
        })
}